import {changeEvent, dispatchCustomEvent} from "../../../../../webpack/modules/events";
import {trackProductPageGa4Events} from "../../../../../webpack/modules-optimized/product";
import {updatePriceElements} from "../../../../../webpack/modules-optimized/product-page";

changeEvent('#product-page .option-inline-selectable input[name="glass-reversed"]', false, function(element) {
    dispatchCustomEvent(
        'productGlassReversedChanged',
        {}
    );
    trackProductPageGa4Events('GlassReversed', element.checked ? 'add' : 'remove');
    updatePriceElements(element.closest('.product-scope'));
});